module.exports = __webpack_public_path__ + "static/media/drop.337fd0dc.mp3";